// React
import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";

// Style
import "./Styles/styles.css";

// Fichier
import HomeMobile from "./pages/Home/HomeMobile";

import Error from "./pages/error/Error";
import Footer from "./components/footer/Footer";

/**
 * @param {{HTMLElement}} rootElement
 * @returns html element
 */
const root = ReactDOM.createRoot(document.getElementById("root"));
document.getElementById("seo-content")?.remove();

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<HomeMobile />} />
        <Route path="*" element={<Error />} />
      </Routes>
      <Footer />
    </BrowserRouter>
  </React.StrictMode>,
);
